<template>
    <div class="d-flex flex-column" style="height: 100%; overflow: hidden">
        <div
            class="d-flex flex-column pa-0 py-0 flex-grow-1 my-1 px-0 mt-0 mb-0 pt-0 containerFull"
            style="height: 100%; overflow: hidden"
        >
            <div class="d-flex flex-column flex-grow-1" style="width: 100%; padding: 20px; z-index: 9">
                <v-sheet class="rounded-lg pa-4 pt-3 pb-3 softShadow agentBox d-flex justify-center flex-column">
                    <v-sheet class="d-flex flex-column rounded mb-6 mt-2 flex-shrink-1" flat outlined style="">
                        <h4 class="d-flex flex-column justify-center align-center py-3">
                            <span style="font-size: 24px; position: relative">
                                <v-icon :color="waitTimeColorR">
                                    {{ waitTimeIconMdi }}
                                </v-icon>
                            </span>
                            <span>
                                {{ waitTime }}
                            </span>
                        </h4>
                    </v-sheet>

                    <v-divider />

                    <div>
                        <v-form ref="form" v-model="valid" class="mt-6 mb-3" :lazy-validation="lazy">
                            <v-textarea
                                style="width: 100%; font-size: 12px !important; align-text: center"
                                filled
                                solo
                                flat
                                background-color="rgb(245,245,245)"
                                label="Ditt telefonnummer"
                                placeholder="Ditt telefonnummer.."
                                autocomplete="off"
                                rows="1"
                                no-resize
                                dense
                                ref="messageRef"
                                hide-details="true"
                                class="send-message-textfield rounded my-3"
                                v-model="phoneNumber"
                                :rules="rulesPhoneNumber"
                            ></v-textarea>

                            <v-select
                                :item-color="primaryColor"
                                :items="timesToCallback"
                                :menu-props="{ top: true, offsetY: true, contentClass: 'softShadow' }"
                                filled
                                solo
                                flat
                                dense
                                background-color="rgb(245,245,245)"
                                :color="primaryColor"
                                label="När?"
                                class="custom-label-color ma-0 pa-0 mb-3"
                                style="width: 100%"
                                v-model="message"
                                :rules="rulesWhenCallingBack"
                            ></v-select>

                            <v-btn
                                v-if="valid"
                                :style="primaryGradientStyle"
                                class="elevation-0 ml-1 my-3 mt-0 pt-0"
                                style="font-size:12px; !important"
                                @click="addCallback(0, '')"
                            >
                                Ställ dig i kö
                            </v-btn>

                            <v-btn
                                v-if="!valid"
                                :disabled="!valid"
                                class="elevation-0 ml-1 my-3 mt-0 pt-0"
                                style="font-size:12px; !important"
                                @click="addCallback(0, '')"
                            >
                                Ställ dig i kö
                            </v-btn>
                        </v-form>
                    </div>
                </v-sheet>
            </div>
        </div>
    </div>

    <!--

    <div style="overflow-y: scroll; width:100%; height:270px; display: block; padding-right:10px; padding-left:10px;">
        <div v-if="config.company == 'Skellefteå Taxi'">
            <br>
            <h2>Välkommen att<br>ringa till oss</h2><br><h4> Vi har öppet dygnet runt</h4>

            <span style="font-size:14px;">
                Boka på
                <br>
                <a href="tel:+4691017000">+46910-170 00</a><br>
            Färdtjänst<br><a :href="'tel:'+config.customer.tele">{{ config.customer.tele }}</a><br>
            <span style="padding-top:15px; font-size:14px;">För att boka sjukresa ring <br><a href="tel:+46771251020">+46 771 25 10 20</a></span></span>
        </div>
        <div v-if="config.company !== 'Skellefteå Taxi' && config.customer.showCallback === false">
                <h4>Kontaktuppgifter</h4>
                <br/>
                <div><b>Telefon: </b> <a :href="'tel:'+config.customer.tele">{{ config.customer.tele }}</a></div>
                <div><b>E-post:</b> {{ config.customer.email }}</div><br>
        </div>

                        <div v-if="smsView" style="">
                            <div v-if="config.customer.showCallback">
                            <div style="margin-top:10px;">Begär återuppringning</div>
                                <v-form
                                    ref="form"
                                    v-model="valid"
                                    :lazy-validation="lazy"
                                >
                                    <div style="">
                                        <v-text-field
                                        color="#006eb0"
                                        class="custom-label-color"
                                        style="float:left; width:50%; margin-right:15px;"
                                        label="Ditt nummer..."
                                        clearable
                                        v-model="phoneNumber"
                                        :rules="rulesPhoneNumber"
                                        >
                                        </v-text-field>
                                    </div>
                                    <div style="padding-top:0px; ">
                                    <v-select
                                        :items="timesToCallback"
                                        :menu-props="{ top: true, offsetY: true }"
                                        color="#006eb0"
                                        label="När?"
                                        class="custom-label-color"
                                        style=" width:40%;"
                                        v-model="message"
                                        :rules="rulesWhenCallingBack"
                                    ></v-select>
                                    </div>
                                <div style="width:100%; float:right; height:20px;">
                                    <v-btn color="#006eb0" style="color:white;" :disabled="!valid" @click="addCallback(0, '')">Begär callback</v-btn>
                                </div>
                                </v-form>
                            </div>
                        </div>
                        <div style="padding:20px;" v-else >
                            <h3>Tack för din begäran</h3>
                            <div>Vi kommer att återkomma.</div>
                        </div>

    </div>

    -->
</template>
<script>
    export default {
        name: 'Phone',
        props: ['config', 'primaryColor', 'secondaryColor', 'primaryGradient'],
        data() {
            return {
                waitTimeColor: '',
                waitTimeMinutes: 2,
                waitTimeIcon: '',
                addCallbackVerified: true,
                smsView: true,
                message: '',
                timesToCallback: ['Omgående', 'Idag', 'Imorgon'],
                phoneNumber: '',
                valid: false,
                lazy: false,
                rulesTextField: [
                    (v) => v.length <= 160 || 'Max 160 ord.',
                    (v) => !!v || 'Du måste skriva något.',
                    (v) => v.length > 5 || 'Du måste skriva minst 5 ord.'
                ],
                rulesPhoneNumber: [
                    (v) => v.length >= 6 || 'Numret måste vara minst 6 tecken',
                    (v) => !!v || 'Du måste ange ett nummer'
                ],
                rulesWhenCallingBack: [(v) => !!v || 'Du måste ange en tidpunkt vi kan ringa upp.'],
                value: '',
                primaryGradientStyle: {
                    backgroundColor: this.primaryGradient,
                    background: this.primaryGradient,
                    color: this.secondaryColor
                },
                primaryStyle: {
                    color: this.primaryColor
                }
            };
        },
        computed: {
            waitTimeColorR() {
                return this.waitTimeColor;
            },

            waitTimeIconMdi() {
                return this.waitTimeIcon;
            },
            waitTime() {
                if (this.waitTimeMinutes > 20) {
                    this.waitTimeIcon = 'mdi-emoticon-sad';
                    this.waitTimeColor = 'red';
                    this.timesToCallback[0] = 'Omgående (över 20 min)';
                    return 'Lång väntetid, över 20 minuter';
                } else if (this.waitTimeMinutes < 4) {
                    this.waitTimeColor = this.primaryColor;
                    this.waitTimeIcon = 'mdi-emoticon';
                    this.timesToCallback[0] = 'Omgående (~3 minuter)';
                    return 'Ingen i kö';
                } else {
                    this.waitTimeIcon = 'mdi-emoticon-neutral';
                    this.waitTimeColor = this.primaryColor;
                    this.timesToCallback[0] = 'Omgående (~' + this.waitTimeMinutes + ' minuter)';
                    return 'Väntetid: ' + this.waitTimeMinutes + ' minuter';
                }
            }
        },
        methods: {
            callNow(nr) {
                window.location.href = 'callto:' + nr;
            },
            addCallback(userId, email) {
                const visitorId = localStorage.getItem('visitorId');

                const dataToSend = {
                    userId: 0,
                    message: this.message,
                    phoneNumber: this.phoneNumber,
                    type: 'callback',
                    visitorId: visitorId,
                    agentName: 'Test',
                    agentUserId: 0,
                    agentEmail: email,
                    visitorInfo: { visitorEmail: this.phoneNumber }
                };

                this.$store.dispatch('sendCallback', dataToSend);

                this.smsView = false;
                let self = this;
                setTimeout(() => {
                    self.smsView = false;
                }, 5000);
            }
        }
    };
</script>

<style scoped>
    :deep .v-label {
        font-size: 12px !important;
    }
    :deep .v-label--active {
        font-size: 12px !important;
        font-weight: bold;
    }

    .v-label {
        font-size: 12px !important;
    }

    .v-select {
        font-size: 12px !important;
    }

    :deep .v-text-field__details {
        padding-top: 10px !important;
    }

    :deep .v-messages {
        text-align: center !important;
    }
    :deep .v-messages__message {
        line-height: 1.5em !important;
    }
</style>
